import { CONTENT_TYPES } from 'core/variables/constant';

function useMaterialPreviewAssigned({ material }) {
  const isQuizTask = material?.content_type_guid === CONTENT_TYPES.TEST || material?.content_type_guid === CONTENT_TYPES.QUESTION;
  const isVideoLesson = material?.content_type_guid === CONTENT_TYPES.VIDEOLESSON;
  const isInProgress =
    material?.content_type_guid === CONTENT_TYPES.FIXED_LAYOUT ||
    material?.content_type_guid === CONTENT_TYPES.OFFICE ||
    material?.content_type_guid === CONTENT_TYPES.PDF;
  const isConsumed =
    material?.content_type_guid === CONTENT_TYPES.AUDIO ||
    material?.content_type_guid === CONTENT_TYPES.IMAGE ||
    material?.content_type_guid === CONTENT_TYPES.LINK ||
    material?.content_type_guid === CONTENT_TYPES.VIDEO;

  // Status:
  const turnedIt = material?.jobs?.filter((item) => item.status === 'delivered')?.length || 0;
  const graded = material?.jobs?.filter((item) => item.score)?.length || 0;
  const consumed = material?.jobs?.filter((item) => item.status === 'delivered')?.length || 0;
  const notConsumed = material?.jobs?.filter((item) => item.status !== 'delivered')?.length || 0;

  return { isQuizTask, isInProgress, isConsumed, isVideoLesson, turnedIt, graded, consumed, notConsumed };
}

export default useMaterialPreviewAssigned;
